import React, { useState } from "react";
import { BsCheckLg, BsArrowRight } from "react-icons/bs";

const Slider = ({screens, handleSubmit}) => {
    const [activeScreen, setActiveScreen] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const handleScreenChange = (newIndex) => {
        if (!isTransitioning && newIndex !== activeScreen && newIndex >= 0 && newIndex < screens.length) {
            setIsTransitioning(true);
            setTimeout(() => {
                setActiveScreen(newIndex);
                setIsTransitioning(false);
            }, 200);
        }
    };

    const renderButton = () => {
        const isLastScreen = activeScreen === screens.length - 1;
        
        return (
            <button 
                className="bg-darkBlue text-white max-w-[64px] min-w-[64px] min-h-[64px] max-h-[64px] h-[64px] w-[64px] rounded-full flex items-center justify-center"
                onClick={isLastScreen ? handleSubmit : () => handleScreenChange(activeScreen + 1)}
            >
                {isLastScreen ? (
                    <BsCheckLg fontSize={30} fontWeight={900}/>
                ) : (
                    <BsArrowRight fontSize={30} fontWeight={900}/>
                )}
            </button>
        );
    };

    const getActiveSlideButtonStyle = (index) => index === activeScreen ? 'w-[40px] h-[8px]' : 'w-[12px] h-[6px] opacity-30';

    return Array.isArray(screens) && screens.length > 0 ? (
            <div className="flex flex-col items-center justify-between w-full h-full px-[20px] mx-auto">
                <div className={`transition-opacity duration-300 w-full flex-1 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
                    {screens[activeScreen]}
                </div>
                <div className="flex flex-col items-center justify-center gap-y-[36px] w-full mt-auto">
                    <div className="flex items-center justify-center gap-x-[8px]">
                        {screens.map((_, index) => (
                            <button 
                                key={index} 
                                className={`rounded-[32px] bg-lightBlue transition-all duration-300 ease-in-out ${getActiveSlideButtonStyle(index)}`}
                                onClick={() => handleScreenChange(index)}
                                disabled={isTransitioning || index === activeScreen} 
                            >
                            </button>
                        ))}
                    </div>
                    {renderButton()}
                </div>
            </div>
    ) : null;
}

export default Slider;